import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { spacing } from '../styles/Rythms'
import { device } from '../styles/Media'
import Social from './Social'
import Logo from './Logo'

const FooterContainer = styled.div`
  .wave-container {
    background: transparent;
    position: relative;
    margin-top: 50px;
  }

  .wave {
    position: absolute;
    width: 100% !important;
    overflow: hidden;
    bottom: -1px;
    left: 0;
  }

  .wave-tablet {
    display: none;
  }

  @media screen and ${device.tablet} {
    .wave-mobile {
      display: none;
    }

    .wave-tablet {
      display: inherit;
    }
  }
`

const StyleFooter = styled.footer`
  background: var(--primary30);
  &.pink {
    background: var(--secondary1-30);
  }
  color: var(--text);
  min-height: 220px;
  width: 100%;
`

const FooterContent = styled.div`
  padding: ${spacing[6]};
  @media screen and ${device.laptopL} {
    max-width: 1440px;
    margin: 0 auto;
  }
`

const TopFooter = styled.div`
  display: grid;
  grid-template-areas:
    'categories'
    'guides'
    'comparatifs'
    'avis'
    'legal'
    'info'
    'about'
    'disclaimer'
    'logo';
  margin: ${spacing[8]} auto ${spacing[4]};
  padding: ${spacing[4]};

  .categories {
    grid-area: categories;
  }

  .guides {
    grid-area: guides;
  }

  .comparatifs {
    grid-area: comparatifs;
  }

  .legal {
    grid-area: legal;
  }

  .info {
    grid-area: info;
  }

  .about {
    grid-area: about;
  }

  .disclaimer {
    grid-area: disclaimer;
  }

  .logo {
    grid-area: logo;
  }

  .avis {
    grid-area: avis;
  }

  @media screen and ${device.tablet} {
    grid-template-areas:
      'categories guides'
      'avis comparatifs'
      'avis legal'
      'avis info'
      'about about'
      'disclaimer disclaimer'
      'logo logo';
  }

  @media screen and ${device.laptop} {
    gap: 20px;
    .guides,
    .info {
      display: flex;
      align-items: center;

      div {
        width: 300px;
      }
    }

    grid-template-areas:
      'categories guides guides comparatifs'
      'avis info info legal'
      'about about disclaimer disclaimer'
      'logo logo disclaimer disclaimer';
  }
`

const BottomFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-xs);
  font-weight: 700;
`

const NavList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing[8]};
  padding-right: ${spacing[2]};

  ul {
    list-style: none;
  }

  li {
    margin-bottom: ${spacing[4]};
  }

  a {
    font-weight: 600;
    color: var(--text);
    cursor: pointer;
  }
}
`

const LogoContainer = styled.div`
  margin: auto;
  width: 131px;
  @media screen and ${device.laptop} {
    margin: 0;
    width: 250px;
    svg {
      width: 100%;
      height: auto;
    }
  }
`

const ListHeader = styled.div`
  font-size: var(--font-lg);
  font-weight: 700;
  font-family: 'Fraunces', serif;
  margin-bottom: ${spacing[6]};
`

const Aside = styled.div`
  .text-content {
    margin-bottom: ${spacing[4]};
    font-size: var(--font-sm);
  }
`

const Waves = ({ color = 'green' }) => {
  const waveColor1 = color === 'pink' ? 'var(--secondary1-20)' : 'var(--primary10)'
  const waveColor2 = color === 'pink' ? 'var(--secondary1-30)' : 'var(--primary30)'
  return (
    <div className="wave-container">
      <svg
        className="wave wave-mobile"
        width="768"
        height="64"
        viewBox="0 0 768 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M0 41.8769C0 41.8769 111.182 17.1242 181.248 25.733C211.34 29.4302 224.468 39.6285 254.976 41.8769C311.811 46.0655 336.954 15.0375 394.24 14.9704C443.624 14.9126 466.739 35.6395 516.096 34.7018C575.034 33.5822 596.797 4.65466 655.36 0.620301C699.226 -2.40156 768 6.59952 768 6.59952V64H0V41.8769Z"
          fill={waveColor1}
        />
        <path
          d="M4.16198 63.5C4.17302 63.4973 4.1841 63.4947 4.19519 63.492C6.83324 62.8591 10.6723 61.9538 15.4748 60.8643C25.0799 58.6852 38.5383 55.7698 53.9502 52.8244C84.7816 46.9322 123.403 40.9258 154.632 40.4466C177.63 40.0937 195.268 42.3348 212.929 44.7918C214.126 44.9584 215.324 45.126 216.523 45.2938C233.015 47.6017 249.849 49.9573 271.349 50.4199C313.117 51.3184 345.022 46.1346 376.896 40.8282L378.506 40.56C409.843 35.3409 441.309 30.1004 482.299 30.4733C507.2 30.6999 526.695 33.1732 545.91 35.6112C547.049 35.7557 548.186 35.9 549.324 36.0437C569.663 38.6134 590.024 40.9906 616.458 40.4466C646.838 39.8214 684.754 34.8301 715.06 29.9988C730.217 27.5826 743.476 25.2056 752.946 23.4325C757.681 22.546 761.469 21.8104 764.074 21.2964C765.376 21.0394 766.383 20.8378 767.064 20.7004C767.228 20.6672 767.374 20.6377 767.5 20.6122V63.5H4.16198Z"
          fill={waveColor2}
          stroke={waveColor2}
        />
      </svg>
      <svg
        className="wave wave-tablet"
        width="834"
        height="80"
        viewBox="0 0 834 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M0 72.1429C0 72.1429 30.6366 51.526 62 49.2857C92 47.1429 123.5 64.2857 154 64.2857C196.634 64.2857 199.893 45.0296 242.5 42.8572C283.509 40.7662 303.978 52.1871 345 50.7143C392.405 49.0123 401.58 24.2857 449 24.2857C497.5 24.2857 512.021 35.9126 539 38.5714C585.303 43.1347 589.587 17.8571 636 17.8571C666.5 17.8571 681 29.2857 711 29.2857C744.689 29.2857 767.5 0 798 0C811.807 0 834 5.71429 834 5.71429V80H0V72.1429Z"
          fill={waveColor1}
        />
        <path
          d="M0 80C0 80 70.5493 53.4529 116.5 55.7143C142.498 56.9937 156.546 66.0592 182.5 68.5714C244.338 74.5571 278.531 48.8528 340.5 47.1428C393.068 45.6923 422.474 59.0452 475 55.7143C531.14 52.1541 548.826 28.515 605 30.7143C643.645 32.2274 676.968 51.6344 715.5 47.1428C749.932 43.1292 764.5 17.1429 800.5 17.1429C815.445 17.1429 834 30.7143 834 30.7143V80H0Z"
          fill={waveColor2}
          stroke={waveColor2}
        />
      </svg>
    </div>
  )
}

const Footer = ({ theme = 'green' }) => {
  const copyright = `Copyright © ${new Date().getFullYear()} Moneylo 💚`

  return (
    <FooterContainer>
      <Waves color={theme} />
      <StyleFooter className={theme}>
        <FooterContent>
          <Social />
          <TopFooter>
            <NavList className="categories">
              <ListHeader className="list-header">Catégories</ListHeader>
              <ul>
                <li>
                  <Link to="/bourse/">Bourse</Link>
                </li>
                <li>
                  <Link to="/immobilier/">Immobilier</Link>
                </li>
                <li>
                  <Link to="/epargne/">Épargne</Link>
                </li>
                <li>
                  <Link to="/placements/">Placements</Link>
                </li>
              </ul>
            </NavList>
            <NavList className="guides">
              <div>
                <ListHeader className="list-header">Nos guides 📒</ListHeader>
                <ul>
                  <li>
                    <Link to="/bourse/comment-investir-en-bourse/">
                      Comment investir en bourse ?
                    </Link>
                  </li>
                  <li>
                    <Link to="/immobilier/comment-investir-dans-immobilier/">
                      Comment investir dans l'immobilier ?
                    </Link>
                  </li>
                  <li>
                    <Link to="/bourse/investissement-socialement-responsable/">
                      Comment investir responsable ?
                    </Link>
                  </li>
                  <li>
                    <Link to="/placements/investir-en-cryptomonnaie/">
                      Comment investir en crypto ?
                    </Link>
                  </li>
                </ul>
              </div>
            </NavList>
            <NavList className="comparatifs">
              <ListHeader className="list-header">Nos comparatifs</ListHeader>
              <ul>
                <li>
                  <Link to="/placements/meilleur-per/">
                    Les meilleurs plan épargne retraite (PER)
                  </Link>
                </li>
                <li>
                  <Link to="/placements/meilleurs-robo-advisors/">Les meilleurs robo-advisors</Link>
                </li>
                <li>
                  <Link to="/placements/meilleure-assurance-vie/">
                    Les meilleures assurances-vie
                  </Link>
                </li>
                <li>
                  <Link to="/bourse/meilleur-pea/">
                    Les meilleurs plan épargne en actions (PEA)
                  </Link>
                </li>
              </ul>
            </NavList>
            <NavList className="avis">
              <ListHeader className="list-header">Avis plateformes pour investir</ListHeader>
              <ul>
                <li>
                  <Link to="/placements/avis-nalo/">Mon avis sur Nalo</Link>
                </li>
                <li>
                  <Link to="/placements/yomoni-avis/">Mon avis sur Yomoni</Link>
                </li>
                <li>
                  <Link to="/placements/avis-linxea/">Mon avis sur Linxea</Link>
                </li>
                <li>
                  <Link to="/placements/ramify-avis/">Mon avis sur Ramify</Link>
                </li>
                <li>
                  <Link to="/placements/avis-goodvest/">Mon avis sur Goodvest</Link>
                </li>
                <li>
                  <Link to="/bourse/trade-republic-avis/">Mon avis sur Trade Republic</Link>
                </li>
                <li>
                  <Link to="/bourse/avis-degiro/">Mon avis sur Degiro</Link>
                </li>
                <li>
                  <Link to="/placements/mon-petit-placement-avis/">Mon avis sur Mon Petit
                    Placement</Link>
                </li>
                <li>
                  <Link to="/bourse/scalable-capital-avis/">Mon avis sur Scalable Capital</Link>
                </li>
                <li>
                  <Link to="/placements/coinhouse-avis/">Mon avis sur Coinhouse</Link>
                </li>
                <li>
                  <Link to="/immobilier/beanstock-avis/">Mon avis sur Beanstock</Link>
                </li>
                <li>
                  <Link to="/bourse/pea-fortuneo-avis/">Mon avis sur le PEA de Fortuneo</Link>
                </li>
                <li>
                  <Link to="/immobilier/bevouac-avis/">Mon avis sur Bevouac</Link>
                </li>
                <li>
                  <Link to="/immobilier/louve-invest-avis/">Mon avis sur Louve Invest</Link>
                </li>
              </ul>
            </NavList>
            <NavList className="legal">
              <ListHeader className="list-header">Légal 👩‍⚖️</ListHeader>
              <ul>
                <li>
                  <Link to="/mentions-legales/">Mentions légales</Link>
                </li>
                <li>
                  <Link to="/politique-de-confidentialite/">
                    Politique de confidentialité & cookies
                  </Link>
                </li>
                <li>
                  <Link to="/cgv/">CGV</Link>
                </li>
              </ul>
            </NavList>
            <NavList className="info">
              <div>
                <ListHeader className="list-header">À propos</ListHeader>
                <ul>
                  <li>
                    <Link to="/a-propos/">Qui sommes-nous ?</Link>
                  </li>
                  <li>
                    <Link to="/inscription-newsletter/">S'inscrire à la newsletter</Link>
                  </li>
                  <li>
                    <Link to="/presse/">Presse</Link>
                  </li>
                  <li>
                    <Link to="/contact/">Contact</Link>
                  </li>
                </ul>
              </div>
            </NavList>
            <Aside className="about">
              <ListHeader>Mieux comprendre Moneylo</ListHeader>
              <div className="text-content">
                <p>
                  Moneylo, c’est un blog et des plateformes sociales sur lesquels on partage{' '}
                  <b>
                    des contenus qui visent à décomplexer, démocratiser et vulgariser le monde de
                    l'investissement
                  </b>{' '}
                  en France. En bref, à rendre l'investissement bien plus accessible qu'il n’en à
                  l’air !
                </p>
              </div>
            </Aside>
            <Aside className="disclaimer">
              <ListHeader>Un message important 👇</ListHeader>
              <div className="text-content">
                <p>
                  Le but de Moneylo, ce n'est pas de vous donner des conseils, et encore moins de
                  vous dire quoi faire. On offre de l’éducation, mais on ne donne aucun conseil en
                  investissement, et on ne recommande aucun investissement en particulier.
                </p>

                <p>
                  Je ne suis pas conseillère en investissement, et je n’ai pas pour objectif de le
                  devenir. Les informations que l'on présente sont seulement données à titre
                  informatif et général : c'est ensuite votre propre responsabilité de décider si
                  les informations présentées sont pertinentes selon votre propre situation.
                </p>

                <p>
                  Pour vous faire accompagner selon votre situation précise, consultez un conseiller
                  financier. N’oubliez pas qu’investir comporte un risque de perte.
                </p>
              </div>
            </Aside>
            <Aside className="logo">
              <LogoContainer>
                <Link to="/">
                  <Logo />
                </Link>
              </LogoContainer>
            </Aside>
          </TopFooter>
          <BottomFooter>
            <div>{copyright}</div>
          </BottomFooter>
        </FooterContent>
      </StyleFooter>
    </FooterContainer>
  )
}

export default Footer
